import React from 'react'

const ReviewCard = () => {
  return (
    <div>ReviewCard</div>
  )
}

export default ReviewCard